import { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext(undefined);

export const THEMES = {
  GOTHIC: 'gothic',      // Dark cathedral theme (default)
  MANUSCRIPT: 'manuscript'  // Light parchment theme
};

export const ThemeProvider = ({ children }) => {
  // Initialize from localStorage or default to gothic
  const [theme, setTheme] = useState(() => {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem('funtzguntz-theme');
      return saved === THEMES.MANUSCRIPT ? THEMES.MANUSCRIPT : THEMES.GOTHIC;
    }
    return THEMES.GOTHIC;
  });

  // Update document class and localStorage when theme changes
  useEffect(() => {
    const root = document.documentElement;
    
    // Remove both theme classes first
    root.classList.remove('theme-gothic', 'theme-manuscript');
    
    // Add the current theme class
    root.classList.add(`theme-${theme}`);
    
    // Persist to localStorage
    localStorage.setItem('funtzguntz-theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === THEMES.GOTHIC ? THEMES.MANUSCRIPT : THEMES.GOTHIC);
  };

  const setGothicTheme = () => setTheme(THEMES.GOTHIC);
  const setManuscriptTheme = () => setTheme(THEMES.MANUSCRIPT);

  const value = {
    theme,
    isGothic: theme === THEMES.GOTHIC,
    isManuscript: theme === THEMES.MANUSCRIPT,
    toggleTheme,
    setGothicTheme,
    setManuscriptTheme,
    setTheme
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export default ThemeContext;
